import { wssProtocol } from "@/common/config"
import { ObjectRepository } from "./repository/object"
import { I18NRepository } from "./repository/i18n"
import { TeltonikaRepository } from "./repository/teltonika"
import { CompanyRepository } from "./repository/company"
import { MachineRepository } from "./repository/machines"
import { UsersRepository } from "./repository/users"
import { SessionService } from "./repository/session"

export class Services {
    companies: CompanyRepository
    machines: MachineRepository
    users: UsersRepository
    objects: ObjectRepository
    teltonika: TeltonikaRepository
    i18n: I18NRepository
    session: SessionService

    constructor() {
        this.companies = new CompanyRepository()
        this.machines = new MachineRepository()
        this.users = new UsersRepository()
        this.objects = new ObjectRepository()
        this.teltonika = new TeltonikaRepository()
        this.i18n = new I18NRepository('pl')
        this.session = new SessionService({
            i18n: this.i18n,
            users: this.users
        })
    }
}